export const AuthLoading = () => <div className="bg-surface flex min-h-screen w-full items-center justify-center p-8">Cargando...</div>
